import { render } from "./UserInvite.vue?vue&type=template&id=9115908a&ts=true"
import script from "./UserInvite.vue?vue&type=script&lang=ts"
export * from "./UserInvite.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__